// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popup-module-popupContainer {
  position: fixed;
  top: 0;
  background-color: var(--popup-container-background);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transition: 0.3s;
  opacity: 0;
}

.Popup-module-popupContainer.Popup-module-open {
  opacity: 1;
}

.Popup-module-popup {
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  transform: scale(0.3);
  opacity: 0;
  transition: 0.3s;
  border-radius: 5px;
}

.Popup-module-popup > form {
  gap: 0;
  height: 100%;
  width: 100%;
}

.Popup-module-popup > form > section {
  flex-direction: row;
}

.Popup-module-popup.Popup-module-visible {
  display: flex;
}

.Popup-module-open > .Popup-module-popup {
  transform: scale(1);
  opacity: 1;
}

@media screen and (min-width: 380px) {

  .Popup-module-popup {
    width: calc(100% - 40px);
    height: initial;
    max-width: 1080px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,mDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE;IACE,wBAAwB;IACxB,eAAe;IACf,iBAAiB;EACnB;;AAEF","sourcesContent":[".popupContainer {\r\n  position: fixed;\r\n  top: 0;\r\n  background-color: var(--popup-container-background);\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1;\r\n  transition: 0.3s;\r\n  opacity: 0;\r\n}\r\n\r\n.popupContainer.open {\r\n  opacity: 1;\r\n}\r\n\r\n.popup {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: none;\r\n  flex-direction: column;\r\n  transform: scale(0.3);\r\n  opacity: 0;\r\n  transition: 0.3s;\r\n  border-radius: 5px;\r\n}\r\n\r\n.popup > form {\r\n  gap: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.popup > form > section {\r\n  flex-direction: row;\r\n}\r\n\r\n.popup.visible {\r\n  display: flex;\r\n}\r\n\r\n.open > .popup {\r\n  transform: scale(1);\r\n  opacity: 1;\r\n}\r\n\r\n@media screen and (min-width: 380px) {\r\n\r\n  .popup {\r\n    width: calc(100% - 40px);\r\n    height: initial;\r\n    max-width: 1080px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var popupContainer = `Popup-module-popupContainer`;
export var open = `Popup-module-open`;
export var popup = `Popup-module-popup`;
export var visible = `Popup-module-visible`;
export default ___CSS_LOADER_EXPORT___;
